/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Card, Button, Form, Modal, Table, Badge } from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash, FaSave, FaTimes, FaLayerGroup, FaBox, FaImage, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { getTKT1FileUploadByID } from '../actions';

// Vật liệu enum
export const MATERIAL_TYPES = {
  MICA_TRONG_2MM: 'MICA_TRONG_2MM',
  MICA_TRONG_3MM: 'MICA_TRONG_3MM',
  MICA_SUA_2MM: 'MICA_SUA_2MM',
  MICA_SUA_3MM: 'MICA_SUA_3MM',
  GO_PLYWOOD_2MM: 'GO_PLYWOOD_2MM',
  GO_PLYWOOD_3MM: 'GO_PLYWOOD_3MM',
  GO_PLYWOOD_4MM: 'GO_PLYWOOD_4MM'
};

export const MATERIAL_NAMES = {
  [MATERIAL_TYPES.MICA_TRONG_2MM]: 'Mica Trong 2mm',
  [MATERIAL_TYPES.MICA_TRONG_3MM]: 'Mica Trong 3mm',
  [MATERIAL_TYPES.MICA_SUA_2MM]: 'Mica Sữa 2mm',
  [MATERIAL_TYPES.MICA_SUA_3MM]: 'Mica Sữa 3mm',
  [MATERIAL_TYPES.GO_PLYWOOD_2MM]: 'Gỗ Plywood 2mm',
  [MATERIAL_TYPES.GO_PLYWOOD_3MM]: 'Gỗ Plywood 3mm',
  [MATERIAL_TYPES.GO_PLYWOOD_4MM]: 'Gỗ Plywood 4mm'
};

class TKT1ONMDesign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      design: {
        id: null,
        name: '',
        description: '',
        layers: []
      },
      showDesignModal: false,
      showLayerModal: false,
      showMaterialModal: false,
      showObjectModal: false,
      currentLayer: null,
      currentMaterial: null,
      currentObject: null,
      editingLayer: null,
      editingMaterial: null,
      editingObject: null,
      showRightPanel: true,
      previewZoom: 1,
      svgCache: {},
      loadingSvgs: {}
    };
  }

  componentDidMount() {
    // Load from localStorage first
    this.loadDesignFromStorage();
    
    // Load SVG data for preview
    this.loadSvgsForPreview();
  }

  componentDidUpdate(prevProps, prevState) {
    // When design changes, reload SVGs
    if (prevState.design !== this.state.design) {
      this.loadSvgsForPreview();
    }
    
    // Update SVG cache when currentFileUpload changes
    if (prevProps.currentFileUpload !== this.props.currentFileUpload && this.props.currentFileUpload) {
      const fileUpload = this.props.currentFileUpload;
      const svgId = fileUpload._id;
      
      if (svgId && !this.state.svgCache[svgId]) {
        let svgContent = null;
        let svgUrl = null;
        
        // Try normalized first, then original
        if (fileUpload.metadata?.normalizedSvgSource) {
          try {
            svgContent = atob(fileUpload.metadata.normalizedSvgSource);
          } catch (err) {
            console.error('Error decoding normalizedSvgSource:', err);
          }
        }
        
        if (!svgContent && fileUpload.metadata?.source_svg) {
          try {
            svgContent = atob(fileUpload.metadata.source_svg);
          } catch (err) {
            console.error('Error decoding source_svg:', err);
          }
        }
        
        // Get URL
        if (fileUpload.s3_key) {
          const bucketName = fileUpload.is_public ? 'tkt1-public-images' : 'tkt1-images';
          const baseUrl = `https://${bucketName}.s3.ap-southeast-2.amazonaws.com`;
          svgUrl = `${baseUrl}/${fileUpload.s3_key}`;
        }
        
        // Get SVG base size from viewBox (normalized SVG typically has viewBox="0 0 100 100")
        let svgBaseSize = 100; // Default for normalized SVG
        if (fileUpload.metadata?.originalViewBox?.w) {
          svgBaseSize = fileUpload.metadata.originalViewBox.w;
        } else if (svgContent) {
          // Try to parse viewBox from SVG content
          try {
            const parser = new DOMParser();
            const svgDoc = parser.parseFromString(svgContent, 'image/svg+xml');
            const svgElement = svgDoc.querySelector('svg');
            if (svgElement) {
              const viewBox = svgElement.getAttribute('viewBox');
              if (viewBox) {
                const parts = viewBox.split(' ');
                if (parts.length >= 4) {
                  svgBaseSize = Math.max(parseFloat(parts[2]) || 100, parseFloat(parts[3]) || 100);
                }
              } else {
                const width = svgElement.getAttribute('width');
                if (width) {
                  svgBaseSize = parseFloat(width) || 100;
                }
              }
            }
          } catch (err) {
            console.error('Error parsing SVG viewBox:', err);
          }
        }

        // Cache the SVG
        this.setState(prevState => ({
          svgCache: {
            ...prevState.svgCache,
            [svgId]: { 
              content: svgContent, 
              url: svgUrl,
              filename: fileUpload.original_filename || fileUpload.filename || null,
              baseSize: svgBaseSize
            }
          },
          loadingSvgs: {
            ...prevState.loadingSvgs,
            [svgId]: false
          }
        }));
      }
    }
  }

  // Load design from localStorage
  loadDesignFromStorage = () => {
    try {
      const storedDesign = localStorage.getItem('onm_design_current');
      if (storedDesign) {
        const design = JSON.parse(storedDesign);
        this.setState({ design });
        toast.success('Đã tải design từ localStorage');
      }
    } catch (error) {
      console.error('Error loading design from localStorage:', error);
    }
  };

  // Save design to localStorage
  saveDesignToStorage = () => {
    try {
      localStorage.setItem('onm_design_current', JSON.stringify(this.state.design));
      console.log('Design saved to localStorage');
    } catch (error) {
      console.error('Error saving design to localStorage:', error);
      toast.error('Lỗi khi lưu vào localStorage');
    }
  };

  // Load SVG content for preview
  loadSvgsForPreview = async () => {
    const { design, svgCache } = this.state;
    const svgIds = new Set();
    
    // Collect all SVG IDs from all layers
    design.layers.forEach(layer => {
      layer.materials.forEach(material => {
        material.objects.forEach(obj => {
          if (obj.svg_id && !svgCache[obj.svg_id]) {
            svgIds.add(obj.svg_id);
          }
        });
      });
    });

    // Load each SVG
    for (const svgId of svgIds) {
      if (!this.state.loadingSvgs[svgId]) {
        this.setState(prevState => ({
          loadingSvgs: { ...prevState.loadingSvgs, [svgId]: true }
        }));
        
        try {
          await this.props.getTKT1FileUploadByID(svgId);
        } catch (error) {
          console.error(`Error loading SVG ${svgId}:`, error);
        }
      }
    }
  };

  // Get SVG URL from cache
  getSvgUrl = (svgId) => {
    return this.state.svgCache[svgId]?.url || null;
  };

  // Get SVG content from cache
  getSvgContent = (svgId) => {
    return this.state.svgCache[svgId]?.content || null;
  };

  // Get filename from cache, fallback to svgId
  getDisplayName = (svgId) => {
    const cached = this.state.svgCache[svgId];
    return cached?.filename || svgId;
  };

  // Get SVG base size from cache
  getSvgBaseSize = (svgId) => {
    const cached = this.state.svgCache[svgId];
    return cached?.baseSize || 100; // Default to 100 for normalized SVG
  };

  // Design Management
  handleCreateNewDesign = () => {
    this.setState({
      design: {
        id: null,
        name: '',
        description: '',
        layers: []
      },
      showDesignModal: true
    });
  };

  handleSaveDesign = () => {
    const { design } = this.state;
    
    if (!design.name) {
      toast.error('Vui lòng điền tên design');
      return;
    }

    // Generate ID if new
    const newDesign = {
      ...design,
      id: design.id || `design_${Date.now()}`,
      created_at: design.created_at || new Date().toISOString(),
      updated_at: new Date().toISOString()
    };

    this.setState({
      design: newDesign,
      showDesignModal: false
    });

    // Save to localStorage
    this.saveDesignToStorage();

    toast.success('Đã lưu thiết kế');
    console.log('Design saved:', newDesign);
  };

  // Layer Management
  handleAddLayer = () => {
    const newLayer = {
      id: `layer_${Date.now()}`,
      name: '',
      description: '',
      order: this.state.design.layers.length + 1,
      materials: []
    };

    this.setState({
      currentLayer: newLayer,
      editingLayer: null,
      showLayerModal: true
    });
  };

  handleEditLayer = (layer) => {
    this.setState({
      currentLayer: layer,
      editingLayer: layer,
      showLayerModal: true
    });
  };

  handleSaveLayer = () => {
    const { currentLayer, editingLayer, design } = this.state;

    if (!currentLayer.name) {
      toast.error('Vui lòng nhập tên layer');
      return;
    }

    const layers = [...design.layers];
    
    if (editingLayer) {
      // Update existing layer
      const index = layers.findIndex(l => l.id === editingLayer.id);
      if (index !== -1) {
        layers[index] = { ...currentLayer };
      }
    } else {
      // Add new layer
      layers.push(currentLayer);
    }

    const updatedDesign = {
      ...design,
      layers
    };

    this.setState({
      design: updatedDesign,
      showLayerModal: false,
      currentLayer: null,
      editingLayer: null
    });

    // Save to localStorage
    setTimeout(() => {
      this.setState({ design: updatedDesign }, () => {
        this.saveDesignToStorage();
      });
    }, 0);

    toast.success(`Đã ${editingLayer ? 'cập nhật' : 'thêm'} layer`);
  };

  handleDeleteLayer = (layerId) => {
    if (window.confirm('Bạn có chắc muốn xóa layer này?')) {
      const { design } = this.state;
      const layers = design.layers.filter(l => l.id !== layerId);

      const updatedDesign = {
        ...design,
        layers
      };

      this.setState({
        design: updatedDesign
      });

      // Save to localStorage
      setTimeout(() => {
        this.setState({ design: updatedDesign }, () => {
          this.saveDesignToStorage();
        });
      }, 0);

      toast.success('Đã xóa layer');
    }
  };

  // Material Management
  handleAddMaterial = (layer) => {
    const newMaterial = {
      type: '',
      name: '',
      objects: []
    };

    this.setState({
      currentLayer: layer,
      currentMaterial: newMaterial,
      editingMaterial: null,
      showMaterialModal: true
    });
  };

  handleEditMaterial = (layer, material) => {
    this.setState({
      currentLayer: layer,
      currentMaterial: material,
      editingMaterial: material,
      showMaterialModal: true
    });
  };

  handleSaveMaterial = () => {
    const { currentLayer, currentMaterial, editingMaterial, design } = this.state;

    if (!currentMaterial.type) {
      toast.error('Vui lòng chọn loại vật liệu');
      return;
    }

    const layers = [...design.layers];
    const layerIndex = layers.findIndex(l => l.id === currentLayer.id);
    
    if (layerIndex === -1) return;

    const materials = [...layers[layerIndex].materials];

    if (editingMaterial) {
      // Update existing material
      const materialIndex = materials.findIndex(m => m.type === editingMaterial.type);
      if (materialIndex !== -1) {
        materials[materialIndex] = {
          ...currentMaterial,
          name: MATERIAL_NAMES[currentMaterial.type] || currentMaterial.name
        };
      }
    } else {
      // Add new material
      materials.push({
        ...currentMaterial,
        name: MATERIAL_NAMES[currentMaterial.type] || currentMaterial.name
      });
    }

    layers[layerIndex].materials = materials;

    const updatedDesign = {
      ...design,
      layers
    };

    this.setState({
      design: updatedDesign,
      showMaterialModal: false,
      currentMaterial: null,
      editingMaterial: null
    });

    // Save to localStorage
    setTimeout(() => {
      this.setState({ design: updatedDesign }, () => {
        this.saveDesignToStorage();
      });
    }, 0);

    toast.success(`Đã ${editingMaterial ? 'cập nhật' : 'thêm'} vật liệu`);
  };

  handleDeleteMaterial = (layerId, materialType) => {
    if (window.confirm('Bạn có chắc muốn xóa vật liệu này?')) {
      const { design } = this.state;
      const layers = [...design.layers];
      const layerIndex = layers.findIndex(l => l.id === layerId);
      
      if (layerIndex !== -1) {
        layers[layerIndex].materials = layers[layerIndex].materials.filter(
          m => m.type !== materialType
        );

        const updatedDesign = {
          ...design,
          layers
        };

        this.setState({
          design: updatedDesign
        });

        // Save to localStorage
        setTimeout(() => {
          this.setState({ design: updatedDesign }, () => {
            this.saveDesignToStorage();
          });
        }, 0);

        toast.success('Đã xóa vật liệu');
      }
    }
  };

  // Object Management
  handleAddObject = (layer, material) => {
    const newObject = {
      id: `obj_${Date.now()}`,
      svg_id: '',
      center_x: 0,
      center_y: 0,
      scale: 1.0,
      rotation: 0
      // boundingBoxSize không được lưu, chỉ tính để hiển thị: boundingBoxSize = scale * 100
    };

    this.setState({
      currentLayer: layer,
      currentMaterial: material,
      editingObject: null,
      showObjectModal: true,
      currentObject: newObject
    });
  };

  handleEditObject = (layer, material, object) => {
    let updatedObject = { ...object };
    
    // Remove boundingBoxSize if exists (chỉ lưu scale)
    delete updatedObject.boundingBoxSize;
    
    // Ensure scale exists, default to 1.0
    if (!updatedObject.scale) {
      updatedObject.scale = 1.0;
    }
    
    // Migrate from old width/height if exists
    if (updatedObject.width || updatedObject.height) {
      // Convert old width/height to scale (assuming base size 100)
      const oldSize = updatedObject.width || updatedObject.height || 100;
      updatedObject.scale = oldSize / 100;
      delete updatedObject.width;
      delete updatedObject.height;
    }
    
    this.setState({
      currentLayer: layer,
      currentMaterial: material,
      editingObject: object,
      showObjectModal: true,
      currentObject: updatedObject
    });
  };

  handleSaveObject = () => {
    const { currentLayer, currentMaterial, currentObject, editingObject, design } = this.state;

    if (!currentObject.svg_id) {
      toast.error('Vui lòng nhập SVG ID');
      return;
    }

    const layers = [...design.layers];
    const layerIndex = layers.findIndex(l => l.id === currentLayer.id);
    
    if (layerIndex === -1) return;

    const materials = [...layers[layerIndex].materials];
    const materialIndex = materials.findIndex(m => m.type === currentMaterial.type);
    
    if (materialIndex === -1) return;

    const objects = [...materials[materialIndex].objects];

    // Prepare object to save - chỉ lưu scale, không lưu boundingBoxSize
    const objectToSave = { ...currentObject };
    delete objectToSave.boundingBoxSize; // boundingBoxSize chỉ để hiển thị

    if (editingObject) {
      // Update existing object
      const objectIndex = objects.findIndex(o => o.id === editingObject.id);
      if (objectIndex !== -1) {
        objects[objectIndex] = objectToSave;
      }
    } else {
      // Add new object
      objects.push(objectToSave);
    }

    materials[materialIndex].objects = objects;
    layers[layerIndex].materials = materials;

    const updatedDesign = {
      ...design,
      layers
    };

    this.setState({
      design: updatedDesign,
      showObjectModal: false,
      currentObject: null,
      editingObject: null
    });

    // Save to localStorage
    setTimeout(() => {
      this.setState({ design: updatedDesign }, () => {
        this.saveDesignToStorage();
      });
    }, 0);

    toast.success(`Đã ${editingObject ? 'cập nhật' : 'thêm'} object`);
  };

  handleDeleteObject = (layerId, materialType, objectId) => {
    if (window.confirm('Bạn có chắc muốn xóa object này?')) {
      const { design } = this.state;
      const layers = [...design.layers];
      const layerIndex = layers.findIndex(l => l.id === layerId);
      
      if (layerIndex !== -1) {
        const materials = [...layers[layerIndex].materials];
        const materialIndex = materials.findIndex(m => m.type === materialType);
        
        if (materialIndex !== -1) {
          materials[materialIndex].objects = materials[materialIndex].objects.filter(
            o => o.id !== objectId
          );
          layers[layerIndex].materials = materials;

          const updatedDesign = {
            ...design,
            layers
          };

          this.setState({
            design: updatedDesign
          });

          // Save to localStorage
          setTimeout(() => {
            this.setState({ design: updatedDesign }, () => {
              this.saveDesignToStorage();
            });
          }, 0);

          toast.success('Đã xóa object');
        }
      }
    }
  };

  // Preview functions
  handleZoomIn = () => {
    this.setState(prevState => ({
      previewZoom: Math.min(prevState.previewZoom + 0.25, 5)
    }));
  };

  handleZoomOut = () => {
    this.setState(prevState => ({
      previewZoom: Math.max(prevState.previewZoom - 0.25, 0.25)
    }));
  };

  handleResetZoom = () => {
    this.setState({ previewZoom: 1 });
  };

  toggleRightPanel = () => {
    this.setState(prevState => ({
      showRightPanel: !prevState.showRightPanel
    }));
  };

  renderPreview = () => {
    const { design, previewZoom } = this.state;

    if (!design.id || design.layers.length === 0) {
      return (
        <div className="d-flex align-items-center justify-content-center h-100" style={{ minHeight: '400px' }}>
          <div className="text-center text-muted">
            <FaImage size={48} className="mb-3" />
            <p>Chưa có layer để preview. Hãy tạo design và thêm layer.</p>
          </div>
        </div>
      );
    }

    return (
      <div 
        ref={(el) => {
          if (el) {
            this.scrollContainer = el;
            // Scroll to center when first rendered
            if (!this.scrollInitialized) {
              const scrollX = (el.scrollWidth - el.clientWidth) / 2;
              const scrollY = (el.scrollHeight - el.clientHeight) / 2;
              el.scrollLeft = scrollX;
              el.scrollTop = scrollY;
              this.scrollInitialized = true;
            }
          }
        }}
        style={{ 
          width: '100%', 
          height: '100%', 
          overflow: 'auto',
          backgroundColor: '#f8f9fa',
          position: 'relative'
        }}
      >
        <div
          style={{
            width: `${3000 * previewZoom}px`,
            height: `${3000 * previewZoom}px`,
            position: 'relative',
            backgroundColor: '#ffffff',
            border: '1px solid #ddd',
            backgroundImage: `
              linear-gradient(to right, #e0e0e0 1px, transparent 1px),
              linear-gradient(to bottom, #e0e0e0 1px, transparent 1px)
            `,
            backgroundSize: `${50 * previewZoom}px ${50 * previewZoom}px`,
            backgroundPosition: '0 0'
          }}
        >
          {/* Center lines */}
          <div
            style={{
              position: 'absolute',
              left: `${1500 * previewZoom}px`,
              top: '0',
              width: `${2 * previewZoom}px`,
              height: '100%',
              backgroundColor: '#999',
              zIndex: 1
            }}
          />
          <div
            style={{
              position: 'absolute',
              left: '0',
              top: `${1500 * previewZoom}px`,
              width: '100%',
              height: `${2 * previewZoom}px`,
              backgroundColor: '#999',
              zIndex: 1
            }}
          />
          {/* Render layers in order */}
          {design.layers
            .sort((a, b) => a.order - b.order)
            .map(layer => (
              <div key={layer.id} style={{ position: 'relative' }}>
                {layer.materials.map(material => (
                  material.objects.map(obj => {
                    const svgContent = this.getSvgContent(obj.svg_id);
                    const svgUrl = this.getSvgUrl(obj.svg_id);

                    if (svgContent) {
                      return (
                        <div
                          key={obj.id}
                          style={{
                            position: 'absolute',
                            left: `${(1500 + (obj.center_x || 0)) * previewZoom}px`,
                            top: `${(1500 + (obj.center_y || 0)) * previewZoom}px`,
                            transform: `translate(-50%, -50%) scale(${(obj.scale || 1) * previewZoom}) rotate(${obj.rotation || 0}deg)`,
                            transformOrigin: 'center center',
                            zIndex: 2
                          }}
                          dangerouslySetInnerHTML={{ __html: svgContent }}
                        />
                      );
                    } else if (svgUrl) {
                      return (
                        <img
                          key={obj.id}
                          src={svgUrl}
                          alt={`SVG ${obj.svg_id}`}
                          style={{
                            position: 'absolute',
                            left: `${(1500 + (obj.center_x || 0)) * previewZoom}px`,
                            top: `${(1500 + (obj.center_y || 0)) * previewZoom}px`,
                            transform: `translate(-50%, -50%) scale(${(obj.scale || 1) * previewZoom}) rotate(${obj.rotation || 0}deg)`,
                            transformOrigin: 'center center',
                            zIndex: 2
                          }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      );
                    }
                    return null;
                  })
                ))}
              </div>
            ))}
        </div>
      </div>
    );
  };

  render() {
    const { 
      design, 
      showDesignModal, 
      showLayerModal, 
      showMaterialModal, 
      showObjectModal,
      currentLayer, 
      currentMaterial, 
      currentObject, 
      showRightPanel, 
      previewZoom 
    } = this.state;

    return (
      <Container fluid className="py-4" style={{ position: 'relative', paddingRight: showRightPanel ? '400px' : '20px' }}>
        <Row className="mb-4">
          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <h3>ONM Design Management</h3>
              <div className="d-flex gap-2">
                <Button variant="primary" onClick={this.handleCreateNewDesign}>
                  <FaPlus className="me-2" />
                  Tạo Design Mới
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        {/* Preview Canvas - Center */}
        <Row className="mb-4">
          <Col>
            <Card style={{ height: '600px', position: 'relative' }}>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Design Preview</h5>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted small">Zoom: {Math.round(previewZoom * 100)}%</span>
                  <Button variant="outline-secondary" size="sm" onClick={this.handleZoomOut} disabled={previewZoom <= 0.25}>
                    <FaChevronLeft />
                  </Button>
                  <Button variant="outline-secondary" size="sm" onClick={this.handleResetZoom}>
                    Reset
                  </Button>
                  <Button variant="outline-secondary" size="sm" onClick={this.handleZoomIn} disabled={previewZoom >= 5}>
                    <FaChevronRight />
                  </Button>
                </div>
              </Card.Header>
              <Card.Body className="p-0" style={{ height: 'calc(100% - 60px)', overflow: 'hidden' }}>
                {this.renderPreview()}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Toggle Button - Always visible when panel is collapsed */}
        {!showRightPanel && (
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={this.toggleRightPanel}
            style={{
              position: 'fixed',
              right: '0',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 1001,
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
              padding: '10px 5px'
            }}
            title="Mở Properties"
          >
            <FaChevronLeft />
          </Button>
        )}

        {/* Floating Right Panel */}
        <div
          style={{
            position: 'fixed',
            right: showRightPanel ? '0' : '-380px',
            top: '60px',
            width: '400px',
            height: 'calc(100vh - 60px)',
            backgroundColor: 'white',
            boxShadow: '-2px 0 10px rgba(0,0,0,0.1)',
            zIndex: 1000,
            transition: 'right 0.3s ease-in-out',
            overflowY: 'auto',
            padding: '20px'
          }}
        >
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0">Properties</h5>
            <Button variant="outline-secondary" size="sm" onClick={this.toggleRightPanel}>
              <FaChevronRight />
            </Button>
          </div>

          {/* Design Info Card */}
          {design.id && (
            <Card className="mb-4">
              <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="mb-0">{design.name || 'Chưa có tên'}</h6>
                  <Button variant="outline-secondary" size="sm" onClick={this.handleCreateNewDesign}>
                    <FaEdit className="me-1" />
                  </Button>
                </div>
              </Card.Header>
              <Card.Body>
                <p className="small mb-2"><strong>Mô tả:</strong> {design.description || '-'}</p>
                <p className="small mb-2"><strong>Ngày tạo:</strong> {design.created_at ? new Date(design.created_at).toLocaleString('vi-VN') : '-'}</p>
                <p className="small mb-0"><strong>Số layers:</strong> {design.layers.length}</p>
              </Card.Body>
            </Card>
          )}

          {/* Layers List */}
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Layers</h5>
              <Button variant="primary" size="sm" onClick={this.handleAddLayer} disabled={!design.id}>
                <FaPlus className="me-1" />
                Thêm Layer
              </Button>
            </Card.Header>
            <Card.Body>
              {design.layers.length === 0 ? (
                <p className="text-muted text-center py-4">
                  Chưa có layer nào. Hãy tạo design mới và thêm layer.
                </p>
              ) : (
                design.layers.map((layer, layerIdx) => (
                  <Card key={layer.id} className="mb-3">
                    <Card.Header className="d-flex justify-content-between align-items-center">
                      <div>
                        <h6 className="mb-0">
                          <FaLayerGroup className="me-2" />
                          {layer.name || `Layer ${layerIdx + 1}`}
                          <Badge bg="secondary" className="ms-2">Thứ tự: {layer.order}</Badge>
                        </h6>
                        {layer.description && <small className="text-muted">{layer.description}</small>}
                      </div>
                      <div className="d-flex gap-2">
                        <Button variant="outline-primary" size="sm" onClick={() => this.handleEditLayer(layer)}>
                          <FaEdit />
                        </Button>
                        <Button variant="outline-danger" size="sm" onClick={() => this.handleDeleteLayer(layer.id)}>
                          <FaTrash />
                        </Button>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      {/* Materials List */}
                      <div className="mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <strong>Vật liệu:</strong>
                          <Button variant="outline-success" size="sm" onClick={() => this.handleAddMaterial(layer)}>
                            <FaPlus className="me-1" />
                            Thêm Vật liệu
                          </Button>
                        </div>
                        {layer.materials.length === 0 ? (
                          <p className="text-muted small">Chưa có vật liệu</p>
                        ) : (
                          layer.materials.map((material) => (
                            <Card key={material.type} className="mb-2">
                              <Card.Body className="py-2">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <div>
                                    <strong><FaBox className="me-1" />{material.name || material.type}</strong>
                                    <Badge bg="info" className="ms-2">{material.type}</Badge>
                                  </div>
                                  <div className="d-flex gap-2">
                                    <Button variant="outline-primary" size="sm" onClick={() => this.handleEditMaterial(layer, material)}>
                                      <FaEdit />
                                    </Button>
                                    <Button variant="outline-danger" size="sm" onClick={() => this.handleDeleteMaterial(layer.id, material.type)}>
                                      <FaTrash />
                                    </Button>
                                  </div>
                                </div>
                                {/* Objects List */}
                                <div>
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <small className="text-muted">Objects ({material.objects.length})</small>
                                    <Button variant="outline-success" size="sm" onClick={() => this.handleAddObject(layer, material)}>
                                      <FaPlus className="me-1" />
                                      Thêm Object
                                    </Button>
                                  </div>
                                  {material.objects.length === 0 ? (
                                    <p className="text-muted small mb-0">Chưa có object</p>
                                  ) : (
                                    <Table striped bordered hover size="sm">
                                      <thead>
                                        <tr>
                                          <th>File Name</th>
                                          <th>Actions</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {material.objects.map((obj) => (
                                          <tr key={obj.id}>
                                            <td>
                                              {this.getDisplayName(obj.svg_id)}
                                            </td>
                                            <td>
                                              <div className="d-flex gap-1">
                                                <Button variant="outline-primary" size="sm" onClick={() => this.handleEditObject(layer, material, obj)}>
                                                  <FaEdit />
                                                </Button>
                                                <Button variant="outline-danger" size="sm" onClick={() => this.handleDeleteObject(layer.id, material.type, obj.id)}>
                                                  <FaTrash />
                                                </Button>
                                              </div>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>
                                  )}
                                </div>
                              </Card.Body>
                            </Card>
                          ))
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                ))
              )}
            </Card.Body>
          </Card>
        </div>

        {/* Design Modal */}
        <Modal show={showDesignModal} onHide={() => this.setState({ showDesignModal: false })} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>{design.id ? 'Chỉnh sửa Design' : 'Tạo Design Mới'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Tên Design *</Form.Label>
                <Form.Control
                  type="text"
                  value={design.name}
                  onChange={(e) => this.setState({ design: { ...design, name: e.target.value } })}
                  placeholder="Nhập tên design"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Mô tả</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={design.description}
                  onChange={(e) => this.setState({ design: { ...design, description: e.target.value } })}
                  placeholder="Nhập mô tả"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showDesignModal: false })}>
              <FaTimes className="me-1" />
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveDesign}>
              <FaSave className="me-1" />
              Lưu
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Layer Modal */}
        <Modal show={showLayerModal} onHide={() => this.setState({ showLayerModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.editingLayer ? 'Chỉnh sửa Layer' : 'Thêm Layer Mới'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Tên Layer *</Form.Label>
                <Form.Control
                  type="text"
                  value={currentLayer?.name || ''}
                  onChange={(e) => this.setState({ currentLayer: { ...currentLayer, name: e.target.value } })}
                  placeholder="Nhập tên layer"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Mô tả</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={currentLayer?.description || ''}
                  onChange={(e) => this.setState({ currentLayer: { ...currentLayer, description: e.target.value } })}
                  placeholder="Nhập mô tả"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showLayerModal: false })}>
              <FaTimes className="me-1" />
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveLayer}>
              <FaSave className="me-1" />
              Lưu
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Material Modal */}
        <Modal show={showMaterialModal} onHide={() => this.setState({ showMaterialModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.editingMaterial ? 'Chỉnh sửa Vật liệu' : 'Thêm Vật liệu Mới'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Loại Vật liệu *</Form.Label>
                <Form.Select
                  value={currentMaterial?.type || ''}
                  onChange={(e) => this.setState({ 
                    currentMaterial: { 
                      ...currentMaterial, 
                      type: e.target.value,
                      name: MATERIAL_NAMES[e.target.value] || ''
                    } 
                  })}
                >
                  <option value="">Chọn loại vật liệu</option>
                  {Object.values(MATERIAL_TYPES).map(type => (
                    <option key={type} value={type}>{MATERIAL_NAMES[type]}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showMaterialModal: false })}>
              <FaTimes className="me-1" />
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveMaterial}>
              <FaSave className="me-1" />
              Lưu
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Object Modal */}
        <Modal show={showObjectModal} onHide={() => this.setState({ showObjectModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.editingObject ? 'Chỉnh sửa Object' : 'Thêm Object Mới'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>SVG ID *</Form.Label>
                <Form.Control
                  type="text"
                  value={currentObject?.svg_id || ''}
                  onChange={(e) => {
                    const svgId = e.target.value;
                    this.setState({ 
                      currentObject: { 
                        ...currentObject, 
                        svg_id: svgId
                      } 
                    });
                  }}
                  placeholder="Nhập ID của file SVG upload"
                />
              </Form.Group>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Center X</Form.Label>
                    <Form.Control
                      type="number"
                      step="0.1"
                      value={currentObject?.center_x || 0}
                      onChange={(e) => this.setState({ currentObject: { ...currentObject, center_x: parseFloat(e.target.value) || 0 } })}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Center Y</Form.Label>
                    <Form.Control
                      type="number"
                      step="0.1"
                      value={currentObject?.center_y || 0}
                      onChange={(e) => this.setState({ currentObject: { ...currentObject, center_y: parseFloat(e.target.value) || 0 } })}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Scale</Form.Label>
                    <Form.Control
                      type="number"
                      step="0.1"
                      min="0.1"
                      value={currentObject?.scale || 1.0}
                      onChange={(e) => {
                        const scale = parseFloat(e.target.value) || 1.0;
                        this.setState({ 
                          currentObject: { 
                            ...currentObject, 
                            scale
                            // boundingBoxSize không được lưu, chỉ tính để hiển thị
                          } 
                        });
                      }}
                    />
                    <Form.Text className="text-muted">
                      Bounding Box: {(currentObject?.scale || 1.0) * 100}
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Rotation (độ)</Form.Label>
                    <Form.Control
                      type="number"
                      step="1"
                      value={currentObject?.rotation || 0}
                      onChange={(e) => this.setState({ currentObject: { ...currentObject, rotation: parseFloat(e.target.value) || 0 } })}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Kích thước Bounding Box</Form.Label>
                    <Form.Control
                      type="number"
                      step="1"
                      min="1"
                      value={(currentObject?.scale || 1.0) * 100}
                      onChange={(e) => {
                        const boundingBoxSize = parseFloat(e.target.value) || 100;
                        const scale = boundingBoxSize / 100;
                        
                        this.setState({ 
                          currentObject: { 
                            ...currentObject, 
                            scale
                            // Không lưu boundingBoxSize, chỉ tính để hiển thị
                          } 
                        });
                      }}
                    />
                    <Form.Text className="text-muted">
                      Scale: {currentObject?.scale || 1.0}
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showObjectModal: false })}>
              <FaTimes className="me-1" />
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveObject}>
              <FaSave className="me-1" />
              Lưu
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentFileUpload: state.tkt1FileUploadManagementReducer.currentFileUpload
  };
};

export default connect(mapStateToProps, { getTKT1FileUploadByID })(TKT1ONMDesign);

